module.exports = __webpack_public_path__ + "static/media/iconwww.09427fff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/iconwww.svg
// module id = 110
// module chunks = 0